import React, { useRef } from 'react';
import { useOnClickOutside } from '~/helpers/helpers';
import { DEFAULT_REACTIONS, ReactionConfig, ReactionType } from '~/types/reaction';

interface IProps {
  currentReaction?: string | null;
  onSelectReaction: (reaction: ReactionType | null) => void;
  onClose: () => void;
  reactions?: ReactionConfig[];
}

const ReactionPicker = ({ currentReaction, onSelectReaction, onClose, reactions = DEFAULT_REACTIONS }: IProps) => {
  const ref = useRef<HTMLDivElement>(null);
  useOnClickOutside(ref, onClose);

  return (
    <div
      ref={ref}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        background: '#fff',
        border: '1px solid #e0e0e0',
        borderRadius: 24,
        padding: '4px 8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
        position: 'absolute',
        bottom: '100%',
        left: 0,
        marginBottom: 4,
        zIndex: 100
      }}
    >
      {reactions.map((r) => {
        const isActive = currentReaction === r.type;
        return (
          <button
            key={r.type}
            onClick={() => onSelectReaction(isActive ? null : r.type)}
            style={{
              background: isActive ? `${r.color}22` : 'transparent',
              border: isActive ? `1.5px solid ${r.color}` : '1.5px solid transparent',
              borderRadius: 16,
              padding: '3px 6px',
              cursor: 'pointer',
              fontSize: 18,
              lineHeight: 1,
              transition: 'transform 0.1s',
            }}
            title={r.type}
          >
            {r.imageUrl
              ? <img src={r.imageUrl} alt={r.type} style={{ width: 20, height: 20, objectFit: 'contain' }} />
              : r.emoji
            }
          </button>
        );
      })}
    </div>
  );
};

export default ReactionPicker;
